import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useResponsive } from '../hooks/useResponsive';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import coeurs from '../coeurs.png';
import fondfleuri from '../fondfleuri.png';
import fondlanterne2 from '../fondlanterne2.png';
import { FaUser, FaShieldAlt, FaHeart, FaUsers, FaLock, FaCheck, FaMedal } from 'react-icons/fa';
import { BsHeart, BsPeople, BsBagCheck } from "react-icons/bs";
import { GrShield } from "react-icons/gr";
import { TfiWrite } from "react-icons/tfi";
import { IoPersonOutline } from "react-icons/io5";
import { BiSearchAlt } from "react-icons/bi";
import { RiChatHeartLine } from "react-icons/ri";

import { useAuth } from '../context/AuthContext';
import NavbarAuth from '../components/NavbarAuth';
const Home = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { isMobile } = useResponsive();

    return (
        <div style={styles.container}>

            {/* Navbar */}
            {user ? <NavbarAuth /> : <Navbar />}

            {/* Hero Section */}
            <section style={{
                position: 'relative',
                height: isMobile ? 'auto' : '480px',
                overflow: 'hidden',
                backgroundImage: `url(${fondfleuri})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                paddingBottom: isMobile ? '64px' : '120px',
            }}>
                {!isMobile && (
                    <div style={{
                        position: 'absolute', top: 0, left: 0,
                        width: '55%', height: '100%',
                        background: 'linear-gradient(to right, rgba(253,245,248,0.97) 60%, rgba(253,245,248,0) 100%)',
                    }} />
                )}
                {isMobile && (
                    <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(253,245,248,0.88)' }} />
                )}
                <div style={{
                    position: 'relative', zIndex: 2,
                    maxWidth: '1200px', margin: '0 auto',
                    padding: isMobile ? '20px 24px 0px' : '40px 64px 100px',
                    minHeight: isMobile ? 'auto' : '540px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: isMobile ? 'center' : 'flex-start', fontFamily: 'Cormorant Garamond, serif'
                }}>
                    <div style={{ maxWidth: isMobile ? '100%' : '44%', textAlign: isMobile ? 'center' : 'left' }}>
                        <h1 style={{ color: '#1a0010', fontWeight: '700', fontSize: isMobile ? '38px' : '54px', lineHeight: '1.15', marginBottom: '16px' }}>
                            {isMobile ? (
                                <>
                                    L'union par l'amour<br />
                                    <span style={{ color: '#781840', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                                        et la sincérité
                                        <img src={coeurs} style={{ height: '44px', marginLeft: '-6px', marginTop: '8px' }} />
                                    </span>
                                </>
                            ) : (
                                <>
                                    L'union par<br />l'amour et la<br />
                                    <span style={{ color: '#781840', display: 'inline-flex', alignItems: 'center' }}>
                                        sincérité
                                        <img src={coeurs} style={{ height: '60px', marginLeft: '-10px', marginTop: '10px' }} />
                                    </span>
                                </>
                            )}
                        </h1>
                        <p style={{ color: '#555', lineHeight: '1.8', fontSize: isMobile ? '15px' : '14px', marginBottom: '24px', maxWidth: '370px' }}>
                            Zawaj & Tawadud est une plateforme de mise en relation sérieuse et éthique, conforme à l'islam et aux valeurs musulmanes.
                        </p>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '28px', justifyContent: isMobile ? 'center' : 'flex-start' }}>
                            <button onClick={() => navigate('/register')} style={styles.heroBtn}>
                                <FaUser style={{ marginRight: '8px' }} /> Créer un compte
                            </button>
                            <button onClick={() => navigate('/about')} style={styles.heroBtnOutline}>
                                <FaUser style={{ marginRight: '8px' }} /> En savoir plus &gt;
                            </button>
                        </div>
                        <div style={{ display: 'inline-flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '12px' : '28px', alignItems: 'flex-start', margin: isMobile ? '0 auto' : '0', textAlign: 'left' }}>
                            {[
                                { icon: <FaShieldAlt color="#781840" size={20} />, title: '100% éthique', sub: 'Conforme à la Sunnah' },
                                { icon: <FaUsers color="#781840" size={20} />, title: 'Profils vérifiés', sub: 'Authenticité garantie' },
                                { icon: <FaLock color="#781840" size={20} />, title: 'Confidentialité', sub: 'Données protégées' },
                            ].map((b, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <span style={{ flexShrink: 0, width: '20px', display: 'flex', justifyContent: 'center' }}>{b.icon}</span>
                                    <div>
                                        <div style={{ color: '#1a0010', fontSize: '14px', fontWeight: '700' }}>{b.title}</div>
                                        <div style={{ color: '#888', fontSize: '14px' }}>{b.sub}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {!isMobile && (
                        <div style={{ position: 'absolute', bottom: '220px', right: '48px', zIndex: 3 }}>
                            <div style={{
                                backgroundColor: 'rgba(74, 0, 40, 0.87)',
                                borderRadius: '16px', padding: '24px 28px',
                                maxWidth: '320px', boxShadow: '0 8px 40px rgba(0,0,0,0.45)',
                            }}>
                                <div style={{ fontSize: '32px', color: 'white', marginBottom: '10px', lineHeight: 1, fontFamily: 'Georgia, serif' }}>"</div>
                                <p style={{ color: 'white', fontSize: '14px', lineHeight: '1.8', margin: 0 }}>
                                    Et parmi Ses signes, Il a créé pour vous des épouses parmi vous-mêmes, afin que vous trouviez auprès d'elles tranquillité, et Il a mis entre vous de l'amour et de la miséricorde.
                                </p>
                                <p style={{ color: 'white', fontSize: '13px', marginTop: '10px', fontWeight: '600', marginBottom: 0 }}>– Sourate Ar-Rûm (30:21)</p>
                            </div>
                        </div>
                    )}
                </div>
            </section>

            {/* 4 Feature Cards */}
            <section style={{ backgroundColor: 'transparent', fontFamily: 'Cormorant Garamond, serif', padding: isMobile ? '16px' : '0 16px', marginTop: isMobile ? '0' : '-60px', position: 'relative', zIndex: 3 }}>
                <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)', maxWidth: '1200px', margin: '0 auto', backgroundColor: 'white', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 4px 32px rgba(192,48,106,0.12), 0 0 0 1px rgba(192,48,106,0.08)' }}>
                    {[
                        { icon: <GrShield size={28} color="#781840" />, title: 'Éthique islamique', text: 'Une plateforme conçue selon les principes de la Sharia' },
                        { icon: <BsPeople size={28} color="#781840" />, title: 'Mise en relation sérieuse', text: "Des profils recherchant le mariage dans l'intention sincère" },
                        { icon: <BsBagCheck size={28} color="#781840" />, title: 'Sécurité & confidentialité', text: 'Vos données sont protégées et jamais partagées' },
                        { icon: <BsHeart size={28} color="#781840" />, title: 'Tawadud au cœur', text: "Favoriser l'amour authentique, le respect et la bienveillance" },
                    ].map((f, i) => (
                        <div key={i} style={{ padding: isMobile ? '20px 12px' : '28px 20px', textAlign: 'center', borderRight: !isMobile && i < 3 ? '1px solid #f5edf1' : i % 2 === 0 && isMobile ? '1px solid #f5edf1' : 'none', borderBottom: isMobile && i < 2 ? '1px solid #f5edf1' : 'none' }}>
                            <div style={{ width: '56px', height: '56px', border: '1px solid #f0dde6', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                                {f.icon}
                            </div>
                            <h3 style={{ color: '#1a0010', fontSize: isMobile ? '13px' : '15px', fontWeight: '700', marginBottom: '8px' }}>{f.title}</h3>
                            <p style={{ color: '#aaa', fontSize: '14px', lineHeight: '1.7', margin: 0 }}>{f.text}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Stats */}
            <section style={{ backgroundColor: '#fff', padding: isMobile ? '16px' : '20px 16px 0px', fontFamily: 'Cormorant Garamond, serif' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', backgroundColor: '#4a0028', borderRadius: '16px' }}>
                    {isMobile ? (
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                            {[
                                { icon: <FaUsers size={20} color="white" />, num: '500+', lbl: 'Membres inscrits' },
                                { icon: <FaShieldAlt size={20} color="white" />, num: '300+', lbl: 'Profils vérifiés' },
                                { icon: <FaHeart size={20} color="white" />, num: '6', lbl: 'Mariages facilités' },
                                { icon: <FaMedal size={20} color="white" />, num: '100%', lbl: "Conforme à l'éthique islamique" },
                            ].map((s, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'flex-start', padding: '16px 12px 16px 18px', borderRight: i % 2 === 0 ? '1px solid rgba(255,255,255,0.08)' : 'none', borderBottom: i < 2 ? '1px solid rgba(255,255,255,0.08)' : 'none' }}>
                                    <span style={{ flexShrink: 0, width: '20px', display: 'flex', justifyContent: 'center' }}>{s.icon}</span>
                                    <div>
                                        <div style={{ color: 'white', fontSize: '18px', fontWeight: '700' }}>{s.num}</div>
                                        <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '11px' }}>{s.lbl}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            {[
                                { icon: <FaUsers size={22} color="white" />, num: '500+', lbl: 'Membres inscrits' },
                                { icon: <FaShieldAlt size={22} color="white" />, num: '300+', lbl: 'Profils vérifiés' },
                                { icon: <FaHeart size={22} color="white" />, num: '6', lbl: 'Mariages facilités' },
                                { icon: <FaMedal size={22} color="white" />, num: '100%', lbl: "Conforme à l'éthique islamique" },
                            ].map((s, i) => (
                                <div key={i} style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'flex-start', padding: '16px 24px', borderRight: i < 3 ? '1px solid rgba(255,255,255,0.08)' : 'none' }}>
                                    <span style={{ flexShrink: 0, width: '22px', display: 'flex', justifyContent: 'center' }}>{s.icon}</span>
                                    <div>
                                        <div style={{ color: 'white', fontSize: '22px', fontWeight: '700' }}>{s.num}</div>
                                        <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '14px' }}>{s.lbl}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* Comment ça marche */}
            <section style={{ backgroundColor: '#fff', fontFamily: 'Cormorant Garamond, serif', padding: isMobile ? '40px 20px' : '40px 80px 40px', textAlign: 'center' }}>
                <p style={{ color: '#781840', fontSize: '11px', fontWeight: '700', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '0px' }}>SIMPLE & SÉCURISÉ</p>
                <h2 style={{ color: '#1a0010', fontSize: isMobile ? '26px' : '44px', fontWeight: '700', marginBottom: '4px' }}>Comment ça marche ?</h2>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginBottom: '40px' }}>
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    <div style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: '#781840' }} />
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                    <div style={{ width: '24px', height: '2px', backgroundColor: '#781840' }} />
                </div>
                <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'center' : 'flex-start', justifyContent: 'center', maxWidth: '1200px', margin: '0 auto', gap: isMobile ? '20px' : '0' }}>
                    {[
                        { icon: <TfiWrite size={28} color="#781840" />, num: '1', title: 'Inscription', text: 'Créez votre compte en quelques minutes.' },
                        { icon: <IoPersonOutline size={28} color="#781840" />, num: '2', title: 'Complétez votre profil', text: 'Renseignez vos informations et préférences.' },
                        { icon: <BiSearchAlt size={28} color="#781840" />, num: '3', title: 'Découvrez des profils', text: 'Trouvez des profils compatibles selon vos critères.' },
                        { icon: <RiChatHeartLine size={28} color="#781840" />, num: '4', title: 'Entamez une relation', text: "Échangez dans le respect et avec l'intention du mariage." },
                    ].map((s, i, arr) => (
                        <React.Fragment key={i}>
                            <div style={{ flex: 1, textAlign: 'center', padding: isMobile ? '0' : '0 8px' }}>
                                <div style={{
                                    width: '80px', height: '80px',
                                    borderRadius: '16px', border: '1px solid #f0dde6',
                                    backgroundColor: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    margin: '0 auto 12px', boxShadow: '0 2px 12px rgba(192,48,106,0.08)',
                                }}>
                                    {s.icon}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '6px' }}>
                                    <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#781840', color: 'white', borderRadius: '50%', width: '24px', height: '24px', fontSize: '12px', fontWeight: '700', flexShrink: 0 }}>{s.num}</div>
                                    <h3 style={{ color: '#1a0010', fontSize: '14px', fontWeight: '700', margin: 0 }}>{s.title}</h3>
                                </div>
                                <p style={{ color: '#aaa', fontSize: '14px', lineHeight: '1.6', textAlign: 'center', margin: 0 }}>{s.text}</p>
                            </div>
                            {i < arr.length - 1 && !isMobile && (
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '3px', flexShrink: 0, marginTop: '38px' }}>
                                    {[...Array(12)].map((_, j) => (
                                        <div key={j} style={{ width: '3px', height: '3px', borderRadius: '50%', backgroundColor: '#f0c0d0', flexShrink: 0 }} />
                                    ))}
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
            </section>

            {/* CTA + Engagements */}
            <section style={{
                margin: isMobile ? '0 12px 12px' : '0 24px 40px',
                borderRadius: '20px', overflow: 'hidden', position: 'relative',
                backgroundImage: `url(${fondlanterne2})`,
                backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat',
                fontFamily: 'Cormorant Garamond, serif'
            }}>
                <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(26,0,16,0)' }} />
                <div style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '24px' : '40px', maxWidth: '900px', margin: '0 auto', padding: isMobile ? '32px 20px' : '32px 48px', alignItems: 'center' }}>
                    <div style={{ flex: 1, textAlign: isMobile ? 'center' : 'left' }}>
                        <h2 style={{ color: 'white', fontSize: isMobile ? '20px' : '28px', fontWeight: '700', lineHeight: '1.4', marginBottom: '12px' }}>
                            Prêt à faire le premier pas vers une union bénie ?
                        </h2>
                        <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: '14px', lineHeight: '1.8', marginBottom: '20px' }}>
                            Rejoignez une communauté sérieuse qui cherche à bâtir des foyers musulmans épanouis.
                        </p>
                        <div style={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}>
                            <button onClick={() => navigate('/register')} style={{ padding: '12px 20px', backgroundColor: '#4a0028', color: 'white', border: '1px solid white', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: '600', display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                                <FaUser size={13} /> Créer un compte gratuitement
                            </button>
                        </div>
                    </div>
                    <div style={{ flex: 1, backgroundColor: 'rgba(255,255,255,0.03)', borderRadius: '14px', padding: '24px', border: '0.1px solid #8a1e4e' }}>
                        <h3 style={{ color: 'white', fontSize: '16px', fontWeight: '700', marginBottom: '16px', textAlign: isMobile ? 'center' : 'left' }}>Nos engagements</h3>
                        {/* Conteneur : centré sur mobile, mais les puces alignées à gauche
                            les unes sous les autres (toutes les coches sur la même verticale). */}
                        <div style={{ display: 'inline-block', textAlign: 'left', margin: isMobile ? '0 auto' : '0', width: isMobile ? '100%' : 'auto' }}>
                            {[
                                'Respect de la vie privée',
                                'Zéro tolérance face aux comportements inappropriés',
                                'Modération humaine et bienveillante',
                                'Plateforme sans mixité non nécessaire',
                            ].map((item, i) => (
                                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '10px', justifyContent: 'flex-start' }}>
                                    <FaCheck color="#c0306a" size={13} style={{ marginTop: '3px', flexShrink: 0 }} />
                                    <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '14px' }}>{item}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <Footer />

        </div>
    );
};

const styles = {
    container: { fontFamily: 'Arial, sans-serif', overflowX: 'hidden' },
    heroBtn: { padding: '12px 20px', backgroundColor: '#4a0028', color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: '700', display: 'inline-flex', alignItems: 'center' },
    heroBtnOutline: { padding: '12px 20px', backgroundColor: 'transparent', color: 'rgba(74, 0, 40, 0.87)', border: '1.5px solid #4a0028', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: '600', display: 'inline-flex', alignItems: 'center' },
};

export default Home;